import { Component, OnInit, ViewChild, Inject, HostListener, OnDestroy } from "@angular/core"; import { Location } from "@angular/common";
import { Table } from 'primeng/table';
import { BreadcrumbService } from '../../app.breadcrumb.service';

import { RequisitionService } from '../../services/requisition-service';
import { RequisitionMin } from '../../entites/requisition-min';
import { MenuItem } from 'primeng/api/menuitem';
import { MessageService, LazyLoadEvent, ConfirmationService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';

import { DialogService } from 'primeng/dynamicdialog';
import { EnvoiRequisitionComponent } from '../../controles/envoi-requisition.component';
import { ItemMin } from 'src/app/entites/item-min';
import { ItemService } from 'src/app/services/item-service';
import { Fournisseur } from 'src/app/entites/fournisseur';
import { BonCommandeEntite } from 'src/app/entites/bon-commande';
import { FournisseurService } from 'src/app/services/fournisseur-service';
import { AchatService } from 'src/app/services/achat-service';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { ProfilService } from 'src/app/services/profil-service';
import { ShortcutService, Shortcut } from '../../services/shortcut.service';
import { NotificationService } from "src/app/services/notification-service";
import { interval } from "rxjs";
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { DonneesBaseService } from "src/app/services/donnees-base-service";
import { SupabaseService } from "src/app/services/supabase.service";
import { Emplacement } from "src/app/entites/emplacement";

/**
 * Interface for action shortcuts displayed in the action shortcuts card
 */
export interface ActionShortcut {
    id: string;
    label: string;
    icon: string;
    gradient: string;
    route?: string;
    action?: () => void;
    tooltip: string;
    permission: string | null;
}

@Component({
    templateUrl: './accueil.component.html',
    styleUrls: ['./accueil.component.scss'],
    styles: [`
        @media screen and (max-width: 960px) {
            :host ::ng-deep .p-datatable.p-datatable-customers.rowexpand-table .p-datatable-tbody > tr > td:nth-child(6) {
                display: flex;
            }
        }

    `],
    providers: [ConfirmationService, DialogService]
})
export class AccueilComponent implements OnInit {


    rowGroupMetadata: any;

    menuContextuelRequisitions: MenuItem[];

    loading: boolean;

    @ViewChild('dt') table: Table;


    rechercheDeclenchee: boolean = false;
    itemsLoaded: boolean = false;
    reqsLoaded: boolean = false;
    fournisseursLoaded: boolean = false;
    bdcsLoaded: boolean = false;

    emplacements: Emplacement[] = [];

    items: ItemMin[];
    reqs: RequisitionMin[];
    fournisseurs: Fournisseur[];
    bdcs: BonCommandeEntite[];

    shortcuts: Shortcut[] = [];
    availableShortcuts: Shortcut[] = [];
    showShortcutDialog = false;
    showShortcutReorderDialog = false;
    shortcutsForReorder: Shortcut[] = [];

    // For compact display
    visibleShortcuts: Shortcut[] = [];
    hiddenShortcuts: Shortcut[] = [];
    maxVisibleShortcuts = Math.min(Math.floor((window.innerWidth) / 146) - 2, 10); // Calculate based on screen width and limit to 10
    isMobile = window.innerWidth <= 768;

    // Action shortcuts - different from navigation shortcuts
    actionShortcuts: ActionShortcut[] = [
        {
            id: 'new-transport',
            label: 'Nouveau transport',
            icon: 'pi pi-arrow-right-arrow-left',
            gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
            route: '/transport/nouveau',
            tooltip: 'Créer un nouveau transport',
            permission: 'requisitions'
        },
        {
            id: 'new-emprunt',
            label: 'Emprunt de matériel',
            icon: 'pi pi-user-plus',
            gradient: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
            action: async () => {
                // Dynamic import to avoid circular dependency with BaseComponent
                const { AjoutEmpruntsComponent } = await import('../emprunts/ajout-emprunts.component');
                this.dialogService.open(AjoutEmpruntsComponent, {
                    header: 'Nouvel emprunt',
                    width: '50%',
                    height: '50%',
                    style: {
                        'overflow-y': 'visible'
                    },
                    maximizable: true
                });
            },
            tooltip: 'Créer un nouveau emprunt de matériel',
            permission: 'emprunt'
        },
        {
            id: 'new-bdc',
            label: 'Nouveau bon de commande',
            icon: 'pi pi-shopping-cart',
            gradient: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
            route: '/achat/nouveau',
            tooltip: 'Créer un nouveau bon de commande',
            permission: 'bdc_creer'
        }
    ];

    constructor(
        private breadcrumbService: BreadcrumbService,
        private profilService: ProfilService,
        public routerService: Router,
        private messageService: MessageService,
        private confirmationService: ConfirmationService,
        public dialogService: DialogService,
        public supabaseService: SupabaseService,
        private shortcutService: ShortcutService,
        protected sdb: DonneesBaseService,
        @Inject(DOCUMENT) private doc: Document) {
        this.breadcrumbService.setItems([
            { label: 'Accueil' }
        ]);
    }

    estAutorise(tache: string) {
        return this.profilService.estAutoriseTache(tache);
    }

    test() {
        this.routerService.navigateByUrl('items');
    }

    loginWithRedirect(redirectUrl: string) {
        this.supabaseService.signInWithSSO(redirectUrl);
    }

    logout() {
        this.supabaseService.signOut();
    }

    profileJson: string = null;
    getProfile() {
        this.supabaseService.user$.subscribe(
            (profile) => {
                this.profileJson = JSON.stringify(profile, null, 2);
            });
    }

    ngOnInit() {
        this.loading = true;
        this.loadShortcuts();
        this.initializeContextMenu();

        if (this.profilService.Profil().roles.find(x => x.nom == 'SIHC_ChargeProjet')) {
            if (this.profilService.Profil().employe.emplacementIdsCP) {
                this.emplacements = this.sdb.EmplacementsComplet().filter(x => this.profilService.Profil().employe.emplacementIdsCP.includes(x.emplacementId));
            } else {
                this.emplacements = [];
            }
        } else {
            this.emplacements = this.sdb.EmplacementsComplet();
        }
    }

    private loadShortcuts() {
        this.shortcutService.shortcuts$.subscribe(shortcuts => {
            this.shortcuts = shortcuts.filter(shortcut => this.estAutorise(shortcut.permission) || !shortcut.permission);
            this.updateVisibleShortcuts();
        });
        this.availableShortcuts = this.shortcutService.getAvailableShortcuts()
            .filter(shortcut => (this.estAutorise(shortcut.permission) || !shortcut.permission) && !shortcut.alwaysShow);
    }

    private updateVisibleShortcuts() {
        // Update mobile detection and max visible shortcuts
        this.isMobile = window.innerWidth <= 768;
        this.maxVisibleShortcuts = Math.floor((window.innerWidth) / 146) - 2;

        // On mobile, show all shortcuts (no hover behavior)
        if (this.isMobile) {
            this.visibleShortcuts = [...this.shortcuts];
            this.hiddenShortcuts = [];
        } else {
            // On desktop, use the hover behavior
            if (this.shortcuts.length <= this.maxVisibleShortcuts) {
                this.visibleShortcuts = [...this.shortcuts];
                this.hiddenShortcuts = [];
            } else {
                this.visibleShortcuts = this.shortcuts.slice(0, this.maxVisibleShortcuts);
                this.hiddenShortcuts = this.shortcuts.slice(this.maxVisibleShortcuts);
            }
        }
    }

    private initializeContextMenu() {
        this.menuContextuelRequisitions = [
            {
                label: 'Gérer les raccourcis',
                icon: 'pi pi-cog',
                command: () => this.showShortcutDialog = true
            },
            {
                label: 'Réorganiser les raccourcis',
                icon: 'pi pi-sort',
                command: () => this.openReorderDialog()
            },
            {
                label: 'Réinitialiser les raccourcis',
                icon: 'pi pi-refresh',
                command: () => this.confirmResetShortcuts()
            }
        ];
    }

    onAddShortcut(shortcut: Shortcut) {
        this.shortcutService.addShortcut(shortcut);
        this.messageService.add({
            severity: 'success',
            summary: 'Raccourci ajouté',
            detail: `Le raccourci "${shortcut.label}" a été ajouté avec succès`
        });
    }

    onRemoveShortcut(shortcut: Shortcut) {
        this.shortcutService.removeShortcut(shortcut.id);
        this.messageService.add({
            severity: 'success',
            summary: 'Raccourci supprimé',
            detail: `Le raccourci "${shortcut.label}" a été supprimé avec succès`
        });
    }

    private confirmResetShortcuts() {
        this.confirmationService.confirm({
            message: 'Êtes-vous sûr de vouloir réinitialiser tous les raccourcis ?',
            accept: () => {
                this.shortcutService.resetToDefault();
                this.messageService.add({
                    severity: 'success',
                    summary: 'Raccourcis réinitialisés',
                    detail: 'Les raccourcis ont été réinitialisés avec succès'
                });
            }
        });
    }

    isShortcutActive(shortcut: Shortcut): boolean {
        return this.shortcuts.some(s => s.id === shortcut.id);
    }

    openExternalLink(href: string) {
        window.open(href, '_blank');
    }

    openReorderDialog() {
        this.shortcutsForReorder = [...this.shortcuts.filter(s => !s.alwaysShow)];
        this.showShortcutReorderDialog = true;
    }

    onReorderDrop(event: CdkDragDrop<Shortcut[]>) {
        moveItemInArray(this.shortcutsForReorder, event.previousIndex, event.currentIndex);
    }

    saveReorder() {
        // Combine always show shortcuts with reordered ones
        const alwaysShowShortcuts = this.shortcuts.filter(s => s.alwaysShow);
        const reorderedShortcuts = [...alwaysShowShortcuts, ...this.shortcutsForReorder];

        this.shortcutService.reorderShortcuts(reorderedShortcuts);
        this.showShortcutReorderDialog = false;

        this.messageService.add({
            severity: 'success',
            summary: 'Ordre modifié',
            detail: 'L\'ordre des raccourcis a été mis à jour avec succès'
        });
    }

    cancelReorder() {
        this.showShortcutReorderDialog = false;
        this.shortcutsForReorder = [];
    }

    @HostListener('window:resize', ['$event'])
    onWindowResize(event: any) {
        this.updateVisibleShortcuts();
    }

    onEmplacementSelect(event: any) {
        this.routerService.navigateByUrl(`/emplacement/${event.option.emplacementId}`);
    }

    /**
     * Executes the action associated with an action shortcut
     * @param action The action shortcut to execute
     */
    executeAction(action: ActionShortcut) {
        // Check permission
        if (action.permission && !this.estAutorise(action.permission)) {
            this.messageService.add({
                severity: 'warn',
                summary: 'Accès refusé',
                detail: 'Vous n\'avez pas les permissions nécessaires pour cette action'
            });
            return;
        }

        // Execute custom action if defined
        if (action.action) {
            action.action();
            return;
        }

        // Navigate to route if defined
        if (action.route) {
            this.routerService.navigateByUrl(action.route);
        }
    }
}
